import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import { mapGoalFormToRequest } from "web_myplann/Goals/Mappers/mapGoalFormToRequest";
import type {
	CreateGoalRequestDTO,
	InspirationTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const mapGoalFormToCreateRequest = (
	data: GoalFormModel,
	inspirationType?: InspirationTypeEnum,
): CreateGoalRequestDTO => ({
	...mapGoalFormToRequest(data),
	investmentPlanCategoryType: data.category,
	inspirationType: inspirationType ?? null,
});
